/* eslint-disable */
/* tslint:disable */
/* auto-generated react proxies */
import { createReactComponent } from './react-component-lib';

import type { JSX } from '@ovhcloud/ods-stencil/components/code/custom-elements';

import { defineCustomElement as defineOsdsCode } from '@ovhcloud/ods-stencil/components/code/custom-elements/osds-code.js';

export const OsdsCode = /*@__PURE__*/createReactComponent<JSX.OsdsCode, HTMLOsdsCodeElement>('osds-code', undefined, undefined, defineOsdsCode);
